
import AlignVertically from "../../../assets/duotone/AlignVertically.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AlignVerticallyIcon({ className, dataTestid = "AlignVerticallyIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <AlignVertically data-testid={dataTestid} className={classes} {...rest} />
  );
}
